export function createRuntimeState() {
  return {
    pendingKeys: new Set(),
    renderVersions: Object.create(null),
  };
}

export function beginPending(runtimeState, key) {
  if (!runtimeState || !key) {
    return false;
  }
  if (runtimeState.pendingKeys.has(key)) {
    return false;
  }
  runtimeState.pendingKeys.add(key);
  return true;
}

export function endPending(runtimeState, key) {
  if (!runtimeState || !key) {
    return;
  }
  runtimeState.pendingKeys.delete(key);
}

export function hasPending(runtimeState) {
  if (!runtimeState || !runtimeState.pendingKeys) {
    return false;
  }
  return runtimeState.pendingKeys.size > 0;
}

export function nextRenderVersion(runtimeState, key) {
  if (!runtimeState || !key) {
    return 0;
  }
  const nextValue = (runtimeState.renderVersions[key] || 0) + 1;
  runtimeState.renderVersions[key] = nextValue;
  return nextValue;
}

export function isCurrentRenderVersion(runtimeState, key, version) {
  if (!runtimeState || !key) {
    return false;
  }
  return runtimeState.renderVersions[key] === version;
}
